import { render, staticRenderFns } from "./SendFamilySafetyConfirmTab.vue?vue&type=template&id=f2ea3fc6&scoped=true&lang=pug"
import script from "./SendFamilySafetyConfirmTab.vue?vue&type=script&lang=ts"
export * from "./SendFamilySafetyConfirmTab.vue?vue&type=script&lang=ts"
import style0 from "./SendFamilySafetyConfirmTab.vue?vue&type=style&index=0&id=f2ea3fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ea3fc6",
  null
  
)

export default component.exports